export default __webpack_public_path__ + "static/tt-norms-regular-1904ffee78e359d16623006ee6660555.woff2";